import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=058ae142&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev-002\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058ae142')) {
      api.createRecord('058ae142', component.options)
    } else {
      api.reload('058ae142', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=058ae142&", function () {
      api.rerender('058ae142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/components/Account.vue"
export default component.exports